import { commonParams } from "../endpoint/EndpointParameters";
import { de_CreatePaymentIntentCommand, se_CreatePaymentIntentCommand, } from "../protocols/Aws_restJson1";
import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class CreatePaymentIntentCommand extends $Command.classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("TempeFabricationPublic", "CreatePaymentIntent", {})
    .n("TempeFabricationPublicClient", "CreatePaymentIntentCommand").f(void 0, void 0)
    .ser(se_CreatePaymentIntentCommand)
    .de(de_CreatePaymentIntentCommand)
    .build() {
}
